import React, { useCallback, useEffect, useRef, useState } from 'react'
import useWebSocketCaller from '../../../../hooks/useWebSocketCaller';
import { useItemListenerContext } from '../../../../providers/ItemListenerContextProvider';
import { reformat } from '../../../../hooks/useMyStrings';
import './ProgKeyEdit.css'
import ConfigErrorMsg from '../ConfigErrorMsg';

export default function ProgKeyEdit({folderPath, keyName, setLabelMode, kInfo, tabIx}) {    
  const taggedEditingRef                  = useRef(false);
  const focusRef                          = useRef(null);
  const [content, setContent]             = useState(kInfo.keyRenamedErrorInfo ? kInfo.keyRenamedErrorInfo.newKey : keyName);
  const {sendMessage}                     = useWebSocketCaller();
  const {tagKeyEditing, clearKeyKInfo}    = useItemListenerContext();
  const [errSubject, setErrSubject]       = useState(null);
  const [errBody, setErrBody]             = useState(null);   
  const [errCause, setErrCause]           = useState(null);


  // const errSubject = kInfo.keyRenamedErrorInfo?.message      || '';
  // const errBody    = kInfo.keyRenamedErrorInfo?.suggestion   || '';

  useEffect(()=>{
    if (kInfo.keyRenamedErrorInfo) {
      const {newKey, message, suggestion, cause} = kInfo.keyRenamedErrorInfo;
      setContent(newKey);
      setErrSubject(message);
      setErrBody(suggestion);
      setErrCause(cause);
      focusRef.current.focus();
      console.log('[ProgKeyEdit] Error: %s', message);
    }
  }, [kInfo?.keyRenamedErrorInfo]);

  // Client only tag. Can be enhanced to server tagging
  useEffect(()=>{
    if (!taggedEditingRef.current) {
      tagKeyEditing(folderPath, keyName)
        .then(()=>taggedEditingRef.current=true);
    }    
  }, [tagKeyEditing, folderPath, keyName]);
  
  
  // Update Local Content
  //
  const updateContent = useCallback((e) => {
    const update = reformat(e.target.value);
    setContent(update);
    // TODO: editValidateMe(update);
  }, []);


  //
  //---[  REVERT  ]---
  //
  const revert = useCallback(()=> {
    if (taggedEditingRef.current) {
      taggedEditingRef.current = false;
      clearKeyKInfo(folderPath, keyName)
        .then(()=>setContent(keyName))
        .then(setLabelMode);
      // Also, prepare for collaboration tag on the server
    }
  },[clearKeyKInfo, folderPath, keyName, setContent, setLabelMode]);


  // ---[  SAVE  ]---
  //
  const save = useCallback(() => {  
    if ( content !== keyName ) {
      console.log('[ProgKeyEdit rename] %s ---> %s', keyName, content);
      sendMessage('rename-config-key', {
        'basePath': folderPath,
        'oldKey': keyName,
        'newKey': content
      });      
    }
    else {
      revert();
    }    
  }, [sendMessage, folderPath, keyName, content, revert]);

  /** [Enter], [Esc] **/
  const handleKeyDown = useCallback((e) => {
    if (e.key === 'Enter') {
      save();
    }
    else if (e.key === 'Escape') {
      revert();
    }
  }, [save, revert]);

  // ---[  Render  ]---


  return (
    <div className='progKeyEdit'>
      {errSubject && <ConfigErrorMsg subject={errSubject}
                                     body={errBody}
                                     cause={errCause}
                                     onSide='left'/>}
      {/* {errSubject && <NoteTooltip subject={errSubject} body={errBody} cause={kInfo.keyRenamedErrorInfo.cause}/>} */}
      <input className='progKeyInput' 
             type='text' value={content}
             autoFocus={true}
             onChange={updateContent} 
             onBlur={save}
             onKeyDown={handleKeyDown}
             tabIndex={tabIx}
             ref={focusRef}
             />
    </div>
  )
}
